import React from 'react';
import { useParallax } from '../../hooks/useParallax';
interface ParallaxImageProps {
  src: string;
  alt: string;
  width: number;
  height: number;
  className?: string;
  /** Vertical travel in pixels across the scroll range (desktop only) */
  strength?: number;
}
export function ParallaxImage({
  src,
  alt,
  width,
  height,
  className = '',
  strength = 40
}: ParallaxImageProps) {
  const {
    containerRef,
    targetRef
  } = useParallax<HTMLDivElement, HTMLImageElement>(strength);
  return <div ref={containerRef} className={`overflow-hidden ${className}`} data-id="element-141" data-mp="2uysuqaf45y4c">
      <img ref={targetRef} src={src} alt={alt} width={width} height={height} loading="lazy" decoding="async" className="h-full w-full scale-110 object-cover" data-id="element-142" data-mp="2zyyihfi9j0h5" />
    </div>;
}